var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 7l-4.5 2.598V4.402L10.75 7z",
    fill: "#20293C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.532 13.667V12.36h3.187c.346 0 .64-.124.885-.373.244-.25.366-.55.366-.903L15 3.307c0-.353-.127-.659-.381-.918a1.219 1.219 0 00-.9-.389H2.281c-.346 0-.646.13-.9.389-.254.26-.381.565-.381.918v7.777c0 .353.127.654.381.903s.554.373.9.373h3.187v1.307h5.064zm3.187-2.581H2.281V3.308H13.72v7.778z",
    fill: "currentColor"
  })));
}
export default SvgLiveView;